import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { HP_COMPETITOR_ID } from '../constants'

import { getCalculatedFieldsForField } from './getCalculatedFieldsForField'

interface IGetCalckedSellThru {
  item: ISobCompetitor
  field: string
  value: number
  hpItem?: ISobCompetitor
}
export const getCalckedSellThruFields = ({ item, hpItem, field, value }: IGetCalckedSellThru) => {
  if (item.CompetitorID === HP_COMPETITOR_ID) {
    return {}
  }
  return getCalculatedFieldsForField({ field, value, hpItem })
}
